// extracted by mini-css-extract-plugin
export var heroSection = "index-module--hero-section--Fh54I";
export var heroSectionBg = "index-module--hero-section-bg--Pp+bq";
export var heroSectionBgBattleMode = "index-module--hero-section-bg-battle-mode--ZGchG";
export var heroSectionLabel = "index-module--hero-section-label--H9CJd";
export var heroSectionTitle = "index-module--hero-section-title--RrB88";
export var heroSectionLeftButton = "index-module--hero-section-left-button--+kMUB";
export var buttonBgPath = "index-module--button-bg-path--qDoCv";
export var buttonsBlock = "index-module--buttons-block--Kb18n";
export var scrollButtonLink = "index-module--scroll-button-link--1CBIC";